/**
 * [KA] Promo tiles — injects promotional cards into the collection product
 * grid at configured positions. Tiles are defined as metaobjects on the
 * collection (see sections/ka-promo-tiles.liquid, which emits the JSON
 * payload this script reads).
 */
(function () {
  const payloadEl = document.querySelector('[data-ka-promo-tiles]');
  if (!payloadEl) return;

  let promos = [];
  try {
    promos = JSON.parse(payloadEl.textContent) || [];
  } catch (e) {
    return;
  }

  function findGrid() {
    return (
      document.querySelector('#product-grid') ||
      document.querySelector('ul#product-grid') ||
      document.querySelector('[data-product-grid]') ||
      document.querySelector('.product-grid') ||
      null
    );
  }

  function getProductItems(grid) {
    const selectors = ['li.product-grid__item', '.product-grid__item', 'li.grid__item', '.grid__item'];

    let raw = [];
    for (const sel of selectors) {
      const items = Array.from(grid.querySelectorAll(sel)).filter(Boolean);
      if (items.length) {
        raw = items;
        break;
      }
    }
    if (!raw.length) raw = Array.from(grid.children);

    const looksLikeProduct = (el) => {
      if (el.classList.contains('ka-promo-card')) return false;
      if (el.querySelector('a[href*="/products/"]')) return true;
      if (el.querySelector('.card, .product-card, .card-wrapper, [data-product-card]')) return true;
      return false;
    };

    const filtered = raw.filter(looksLikeProduct);
    return filtered.length ? filtered : raw;
  }

  function setAspectFromFirstProduct(grid, productItems) {
    const first = productItems && productItems[0];
    if (!first) return;

    const box =
      first.querySelector('.card-gallery') ||
      first.querySelector('.product-card__image') ||
      first.querySelector('.card__media') ||
      first.querySelector('.media') ||
      first.querySelector('img');

    if (!box) return;

    const cs = getComputedStyle(box);
    if (cs.aspectRatio && cs.aspectRatio !== 'auto') {
      grid.style.setProperty('--ka-product-aspect', cs.aspectRatio);
      return;
    }

    const rect = box.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      grid.style.setProperty('--ka-product-aspect', `${Math.round(rect.width)} / ${Math.round(rect.height)}`);
    }
  }

  function buildPromoNode(promo, grid) {
    const wrapper = document.createElement(grid.tagName.toLowerCase() === 'ul' ? 'li' : 'div');
    wrapper.className = 'product-grid__item ka-promo-card';
    if (promo.gradient) wrapper.classList.add('ka-promo-card--gradient');
    if (promo.image_url) wrapper.classList.add('ka-promo-card--has-image');

    const inner = document.createElement('div');
    inner.className = 'ka-promo-card__inner product-card';

    if (promo.bg) inner.style.setProperty('--ka-bg', promo.bg);
    if (promo.font) inner.style.setProperty('--ka-font', promo.font);

    const media = document.createElement('div');
    media.className = 'ka-promo-card__media';

    if (promo.image_url) {
      const img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = promo.internal_name || promo.preheader || 'Promotion';
      img.src = promo.image_url;
      media.appendChild(img);
    }

    const shade = document.createElement('div');
    shade.className = 'ka-promo-card__shade';

    const content = document.createElement('div');
    content.className = 'ka-promo-card__content';

    if (promo.preheader) {
      const pre = document.createElement('p');
      pre.className = 'ka-promo-card__preheader';
      pre.textContent = promo.preheader;
      content.appendChild(pre);
    }
    if (promo.cta) {
      const cta = document.createElement('p');
      cta.className = 'ka-promo-card__cta';
      cta.textContent = promo.cta;
      content.appendChild(cta);
    }

    if (promo.link) {
      const a = document.createElement('a');
      a.className = 'ka-promo-card__link';
      a.href = promo.link;
      if (promo.open_in_new_tab) {
        a.target = '_blank';
        a.rel = 'noopener';
      }
      inner.appendChild(a);
    }

    inner.appendChild(media);
    inner.appendChild(shade);
    inner.appendChild(content);
    wrapper.appendChild(inner);
    return wrapper;
  }

  function inject() {
    const grid = findGrid();
    if (!grid) return;
    if (grid.querySelector('.ka-promo-card')) return;

    const productItems = getProductItems(grid);
    if (!productItems.length) return;

    requestAnimationFrame(() => setAspectFromFirstProduct(grid, productItems));

    const active = promos
      .filter((p) => p && p.enabled)
      .map((p) => ({
        ...p,
        placement: parseInt(p.placement, 10) || 1,
        priority: parseInt(p.priority, 10) || 0,
      }));

    if (!active.length) return;

    active.sort((a, b) => {
      if (a.placement !== b.placement) return b.placement - a.placement;
      return b.priority - a.priority;
    });

    active.forEach((promo) => {
      const idx = promo.placement - 1;
      const node = buildPromoNode(promo, grid);

      if (idx >= 0 && idx < productItems.length) {
        productItems[idx].parentNode.insertBefore(node, productItems[idx]);
      } else {
        grid.appendChild(node);
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(inject);
  document.addEventListener('shopify:section:load', inject);
  document.addEventListener('shopify:section:select', inject);
})();
